module.exports = __webpack_public_path__ + "img/007.48393239.png";